import { Button } from '@progress/kendo-react-buttons'
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs'
import React, { useEffect } from 'react'
import useTranslation from '../../hooks/useTranslation';
import useLocale from '../../hooks/useLocale';

type Props = {
    bulkDownloadSizeInGb: number;
    onClose: () => void;
}

const BulkDownloadLimitDialog: React.FC<Props> = ({ bulkDownloadSizeInGb, onClose }) => {
    const trans = useTranslation("BulkDownloadLimitDialog")
    const localeCtx = useLocale();

    useEffect(() => {
        if (
            !localeCtx?.selectedLocale?.current.componentTranslations["BulkDownloadLimitDialog"]
        ) {
            trans.fetchTranslations("BulkDownloadLimitDialog");
        }
    }, [localeCtx?.selectedLocale]);

    return (
        <Dialog
            title={trans.fetchLabelKeyTranslation("ExportDataText", "Export data")}
            onClose={onClose}
            style={{ zIndex: 999 }}
        >
            <div className="bulk-limit-dialog h-100" style={{ minWidth: 300 }}>
                <div className="dialogContent">
                    <div style={{ textAlign: "center" }}>
                        <div className="formBoxRow fs-14 font-weight-bold mb-3">
                            {trans.fetchLabelKeyTranslation("SizeExceededText", "Total download file size exceeded")}
                        </div>

                        <div className="formBoxRow fs-14 mb-3">
                            {trans.fetchLabelKeyTranslation("ReduceSizeText", "Please reduce the number of selected recordings")}
                        </div>

                        <div className="formBoxRow fs-14 mb-3">
                            {trans.fetchLabelKeyTranslation("DownloadLimitText", "Download limit")} = {bulkDownloadSizeInGb.toFixed(2)} {trans.fetchLabelKeyTranslation("GBText", "GB")}
                        </div>
                    </div>
                </div>
            </div>
            <DialogActionsBar>
                <Button className="btn" onClick={onClose}>
                    {trans.fetchLabelKeyTranslation("OkText", "Ok")}
                </Button>
            </DialogActionsBar>
        </Dialog>
    )
}

export default BulkDownloadLimitDialog;
